import { getData, postRequestWithFormData } from '../utils/HelperFunctions';

export const getAllQbClassesForTable = async (paramsObject = {}) => {
    try {
        // Try paginated endpoint first
        console.log('Calling QB Classes paginated API with params:', paramsObject);
        const response = await getData(paramsObject, 'v1/quickbooks_classes/paginated');
        console.log('QB Classes paginated API response:', response);

        const { QbClasses, meta } = response;
        let qbClassesList = QbClasses.map(item => {
            return item.QbClass;
        });
        return {
            qbClassesList,
            meta,
        };
    } catch (error) {
        console.error('Paginated endpoint failed, falling back to regular endpoint:', error);

        // Fallback to regular endpoint with client-side pagination
        const response = await getData(paramsObject, 'v1/quickbooks_classes');
        console.log('QB Classes regular API response:', response);

        let qbClassesList = response.QbClasses
            ? response.QbClasses.map(({ QbClass }) => QbClass)
            : [];

        // Client-side filtering and pagination
        const total = qbClassesList.length;
        const currentPage = paramsObject.current_page || 1;
        const perPage = paramsObject.per_page || 10;
        const startIndex = (currentPage - 1) * perPage;
        const endIndex = startIndex + perPage;

        // Apply filtering if specified
        if (paramsObject.filter && paramsObject.filter !== 'all') {
            if (paramsObject.filter === 'active') {
                qbClassesList = qbClassesList.filter(item => item.hidden === 'No');
            } else if (paramsObject.filter === 'inactive') {
                qbClassesList = qbClassesList.filter(item => item.hidden === 'Yes');
            }
        }

        // Apply pagination
        const paginatedList = qbClassesList.slice(startIndex, endIndex);

        return {
            qbClassesList: paginatedList,
            meta: {
                total: qbClassesList.length,
                current_page: currentPage,
                per_page: perPage,
            },
        };
    }
};

export const createNewQbClass = async (data, paramsObject = {}) => {
    const res = await postRequestWithFormData(data, 'v1/quickbooks_classes', paramsObject);
    return res.QbClass;
};

export const updateExistingQbClass = async (data, paramsObject = {}) => {
    const res = await postRequestWithFormData(
        data,
        'v1/quickbooks_classes/' + data.id,
        paramsObject
    );
    return res.QbClass;
};

export const activateQbClass = async (id, paramsObject = {}) => {
    const res = await postRequestWithFormData(
        {},
        'v1/quickbooks_classes/' + id + '/activate',
        paramsObject
    );
    return res.QbClass;
};

export const deactivateQbClass = async (id, paramsObject = {}) => {
    const res = await postRequestWithFormData(
        {},
        'v1/quickbooks_classes/' + id + '/deactivate',
        paramsObject
    );
    return res.QbClass;
};
